// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1mYYZ","list":"PatternAutocomplete_list__2wg1l"};